import React, { useState, useEffect } from "react";

import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  MenuItem,
  Select,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Box,
  Checkbox,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  useTheme,
  Dialog,
  DialogContent,
  CardActions,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import InventoryIcon from "@mui/icons-material/Inventory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BarChartIcon from "@mui/icons-material/BarChart";
import SettingsIcon from "@mui/icons-material/Settings";
import axios from "axios";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Autocomplete } from "@mui/material";
import { Chip, ListSubheader } from "@mui/material";
import PaymentIcon from "@mui/icons-material/Payment";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import PersonIcon from "@mui/icons-material/Person";

import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  useMediaQuery,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { Snackbar } from "@mui/material";
import Header3 from "../../Component/Header3";
import ChatWithCustomer from "../../Component/Chatbot/ChatWithCustomer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

const CustomerDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // ✅ Moved this up
  const open = Boolean(anchorEl); // ✅ Now it's safe to use
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState("");
  const [shopProfile, setShopProfile] = useState(null);
  const [inventory, setInventory] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  const [snackbar, setSnackbar] = useState({ open: false, msg: "" });
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [order, setOrder] = useState("asc");
  const [groupFilter, setGroupFilter] = useState("");
  const [subGroupFilter, setSubGroupFilter] = useState("");
  const [availableGroups, setAvailableGroups] = useState([]);
  const [availableSubGroups, setAvailableSubGroups] = useState([]);
  const [preferredShops, setPreferredShops] = useState([]); // array of sID strings
  const [showAllShops, setShowAllShops] = useState(true);
  const [shopInputValue, setShopInputValue] = useState(""); // for input-based search (optional)
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openQtyDialog, setOpenQtyDialog] = useState(false);
  const [mode, setMode] = useState("COUNT");
  const [quantity, setQuantity] = useState(1);
  const location = useLocation();
  // ✅ YAHAN ADD KARNA HAI
  // MobileUI base COde UI ,Functiloity code like FLutter-react convereted code
  const [cart, setCart] = useState([]);
  const unit = selectedProduct?.uom?.toLowerCase();

  const customerName = localStorage.getItem("customerName") || "Customer Name";

  // Guard against reaching this dashboard via browser back/forward after logout -
  // client-side routing re-renders this component on popstate without a full
  // reload, so without this check a cleared session would still show cached data.
  useEffect(() => {
    const isLoggedIn = () => !!localStorage.getItem("customerId");

    if (!isLoggedIn()) {
      navigate("/MyAccountsSignIn", { replace: true });
      return;
    }

    // Re-check when a bfcache-restored page (e.g. after forward navigation) is shown.
    const handlePageShow = (event) => {
      if (event.persisted && !isLoggedIn()) {
        navigate("/MyAccountsSignIn", { replace: true });
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [navigate]);

  //const [permissions, setPermissions] = useState({ orderInventory: 0 });
  //const[buttons,setButtons]=useState("");

  // const buttons = [

  //    { label: "My Orders", icon: <DashboardIcon />, path: "/myorders" },
  // { label: "PaymentDetails", icon: <DashboardIcon />, path: "/paymentdetails" },

  //   { label: "Analytics", icon: <BarChartIcon /> },
  //   { label: "Settings", icon: <SettingsIcon /> },

  // New UI Requirment for CustomerInvertoy time = 10 march 26
  // MobileUI base COde UI ,Functiloity code like FLutter-react convereted code

  const getPrice = () => {
    if (!selectedProduct) return 0;
    return selectedProduct.customPrice ?? selectedProduct.mrp ?? 0;
  };

  const isWeightProduct = selectedProduct?.uom?.toLowerCase().includes("kg");

  const handleOpenProduct = (product) => {
    setSelectedProduct(product);

    const unit = product.uom?.toLowerCase();

    if (unit === "kg") setMode("WEIGHT");
    else setMode("COUNT");

    setQuantity(1);

    setOpenQtyDialog(true);
  };
  useEffect(() => {
    localStorage.removeItem("cart");
  }, []);
  const handleAddToCart = () => {
    const item = {
      productId: selectedProduct.productId,
      productName: selectedProduct.productName,
      price: Number(getPrice()),
      quantity: Number(quantity),
      uom: selectedProduct.uom,
    };
    const existingCart = JSON.parse(localStorage.getItem("cart") || "[]");

    const updatedCart = [...existingCart, item];

    localStorage.setItem("cart", JSON.stringify(updatedCart));

    setCart(updatedCart);

    setOpenQtyDialog(false);
    setQuantity(1);
  };

  const cartTotal = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );

  const totalAmount = getPrice() * quantity;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const qrShopId = params.get("sID");
    if (qrShopId) {
      const shopIdNum = Number(qrShopId); // ✅ convert
      const userLoggedIn = localStorage.getItem("cID");
      if (userLoggedIn) {
        savePreferred(shopIdNum);
        navigate(`/customer-dashboard?shopId=${shopIdNum}`);
      } else {
        navigate(`/CustomerProfileRegistration?shopId=${shopIdNum}`);
      }
    }
  }, [location.search]); // depend on URL change

  //
  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    if (!customerId) return;

    axios
      .get(`https://sakhisshop.com/api/customers/${customerId}/shops`)
      .then((res) => {
        console.log("Registered shops:", res.data);

        // 👇 IMPORTANT: full shop objects
        setShops(res.data);

        // optional: sirf IDs store karna ho
        const ids = res.data.map((shop) => shop.sID);
        localStorage.setItem("registeredShopIds", JSON.stringify(ids));
      })
      .catch((err) => {
        console.error("Registered shop load error:", err);
      });
  }, []);

  // Listen for scan updates
  useEffect(() => {
    const handler = (e) => {
      const allShops = JSON.parse(localStorage.getItem("allShops")) || [];
      const updated = e.detail.filter((id) =>
        allShops.some((s) => s.sID === id),
      );
      setPreferredShops(updated.slice(0, 5));
    };

    window.addEventListener("preferredShopsUpdated", handler);
    return () => window.removeEventListener("preferredShopsUpdated", handler);
  }, []);

  // 🔔 Listen for preferred shop updates
  useEffect(() => {
    const handler = (e) => {
      const allShops = JSON.parse(localStorage.getItem("allShops")) || [];

      const updatedIds = (e.detail || []).filter((id) =>
        allShops.some((shop) => shop.sID === id),
      );

      setPreferredShops(updatedIds.slice(0, 5));
    };

    window.addEventListener("preferredShopsUpdated", handler);

    return () => {
      window.removeEventListener("preferredShopsUpdated", handler);
    };
  }, []);

  // --- Save preferred shop (most recent first, max 5, no duplicates) ---

  const savePreferred = (shopId) => {
    const customerId = Number(localStorage.getItem("customerId"));
    const shopIdNum = Number(shopId);

    if (!customerId || !shopIdNum) {
      console.error("Invalid customer or shop ID");
      return;
    }

    axios
      .post(
        `https://sakhisshop.com/api/customers/${customerId}/preferredShops/${shopIdNum}`,
      )
      .then(() => {
        console.log("Preferred shop saved in backend");
      })
      .catch((err) => {
        console.error("Failed to save preferred:", err);
      });
  };

  const handleShopSelect = async (shopkeeperId) => {
    // 🔒 safety guard
    if (!shopkeeperId || shopkeeperId === "more" || shopkeeperId === "less") {
      console.error("Invalid shopkeeperId:", shopkeeperId);
      return;
    }

    setSelectedShop(shopkeeperId);
    setInventory([]);
    setShopProfile(null);

    try {
      // 🔹 shop profile
      const shopRes = await axios.get(
        `https://sakhisshop.com/api/shops/${shopkeeperId}`,
      );
      setShopProfile(shopRes.data);

      // ✅ YAHI SAVE KARO (FINAL FIX)
      localStorage.setItem("selectedShopId", shopRes.data.sID);
      localStorage.setItem("shopName", shopRes.data.shopname);
      localStorage.setItem("shopAddress", shopRes.data.address);
    } catch (err) {
      console.error("Shop profile error:", err);
    }

    try {
      // 🔹 inventory
      const invRes = await axios.get(
        `https://sakhisshop.com/api/shopkeeper/${shopkeeperId}/inventory`,
      );

      const inventoryList = (invRes.data.inventory || []).map((item) => ({
        ...item,
        id: item.productId ?? item.id,
        type: "default",
        customPrice:
          typeof item.customPrice === "number" ? item.customPrice : item.mrp,
      }));

      const customList = (invRes.data.customProducts || []).map((item) => ({
        ...item,
        type: "custom",
        customPrice: item.customPrice ?? item.mrp,
      }));

      const fullList = [...inventoryList, ...customList];

      setInventory(fullList);

      setAvailableGroups([
        ...new Set(fullList.map((p) => p.group).filter(Boolean)),
      ]);

      setAvailableSubGroups([
        ...new Set(fullList.map((p) => p.subCategory).filter(Boolean)),
      ]);
    } catch (err) {
      console.error("Inventory fetch failed:", err);
      alert("Inventory fetch failed.");
    }
  };

  const handleProductSelection = (product) => {
    const key = product.productId ?? product.inventoryId ?? product.id;

    setSelectedProducts((prev) =>
      prev.some((item) => {
        const itemKey = item.productId ?? item.inventoryId ?? item.id;
        return itemKey === key;
      })
        ? prev.filter((item) => {
            const itemKey = item.productId ?? item.inventoryId ?? item.id;
            return itemKey !== key;
          })
        : [...prev, product],
    );
  };

  // const handleAddToCart = () => {
  //   if (!selectedProducts || selectedProducts.length === 0) {
  //     setSnackbar({ open: true, msg: "Select at least one product!" });
  //     return;
  //   }
  //   // Ensure each product has at least quantity 1
  //   const productsWithQuantity = selectedProducts.map((product) => {
  //     const finalPrice = typeof product.customPrice === 'number' ? product.customPrice : product.mrp;
  //     return {
  //       ...product,
  //       quantity: product.quantity || 1,
  //       price: finalPrice  // ✅ Set correct price here
  //     };
  //   });
  //   sessionStorage.setItem("selectedShop", JSON.stringify(shopProfile));
  //   sessionStorage.setItem("selectedProducts", JSON.stringify(productsWithQuantity));
  //   navigate("/mycart");
  // };

  //...... 11 march comment code some reaosn like**************

  // const handleAddToCart = () => {
  //   if (!selectedProducts || selectedProducts.length === 0) {
  //     setSnackbar({ open: true, msg: "Select at least one product!" });
  //     return;
  //   }

  //   const productsWithQuantity = selectedProducts.map((product) => {
  //     const finalPrice =
  //       typeof product.customPrice === "number"
  //         ? product.customPrice
  //         : product.mrp;

  //     return {
  //       ...product,
  //       quantity: product.quantity ?? 1,
  //       price: finalPrice,
  //     };
  //   });

  //   sessionStorage.setItem(
  //     "selectedShop",
  //     JSON.stringify(shopProfile)
  //   );
  //   sessionStorage.setItem(
  //     "selectedProducts",
  //     JSON.stringify(productsWithQuantity)
  //   );

  //   navigate("/mycart");
  // };

  //Popup ke Add To Cart button
  const handleAddSingleProduct = () => {
    if (!selectedProduct) return;

    const finalPrice =
      typeof selectedProduct.customPrice === "number"
        ? selectedProduct.customPrice
        : selectedProduct.mrp;

    const productWithQty = {
      ...selectedProduct,
      quantity: quantity,
      price: finalPrice,
    };

    setSelectedProducts((prev) => [...prev, productWithQty]);

    setOpenQtyDialog(false);
  };

  // const handleAddToCart = () => {
  //   if (!selectedProducts || selectedProducts.length === 0) {
  //     setSnackbar({ open: true, msg: "Select at least one product!" });
  //     return;
  //   }

  //   const productsWithQuantity = selectedProducts.map((product) => {
  //     const finalPrice =
  //       typeof product.customPrice === "number"
  //         ? product.customPrice
  //         : product.mrp;

  //     return {
  //       ...product,
  //       quantity: product.quantity || 1,
  //       price: finalPrice,
  //     };
  //   });

  //   sessionStorage.setItem(
  //     "selectedProducts",
  //     JSON.stringify(productsWithQuantity)
  //   );

  //   navigate("/mycart");
  // };

  // const theme = createTheme({
  //   palette: {
  //     mode: darkMode ? "dark" : "light",
  //     primary: {
  //       main: darkMode ? "#90caf9" : "#1976d2",
  //     },
  //     background: {
  //       default: darkMode ? "#121212" : "#f5f5f5",
  //       paper: darkMode ? "#1e1e1e" : "#fff",
  //     },
  //   },
  // });

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileUpdate = () => {
    handleMenuClose();
    navigate("/updateCustomerProfile"); // replace with your actual update route
  };

  const handleLogout = () => {
    localStorage.clear(); // clear user info from storage
    handleMenuClose();
    navigate("/MyAccountsSignIn"); // back to login
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const cardStyle = {
    height: 160,
    width: "100%",
    borderRadius: 1,
    background: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
    },
  };

  const computedOptions = React.useMemo(() => {
    if (!shops || shops.length === 0) {
      return []; // ⬅ important guard
    }

    const preferredObjects = preferredShops
      .map((id) => shops.find((s) => String(s?.sID) === String(id)))
      .filter(Boolean)
      .map((s) => ({ ...s, __isPreferred: true }));

    const remainingObjects = shops
      .filter((s) => !preferredShops.some((id) => String(id) === String(s.sID)))
      .map((s) => ({ ...s, __isPreferred: false }));

    if (showAllShops) {
      return [
        ...preferredObjects,
        ...remainingObjects,
        { sID: "less", shopname: "⬆ Show Less", __isSpecial: true },
      ];
    }
    const moreExists = remainingObjects.length > 0;

    return [
      ...preferredObjects,
      ...(moreExists
        ? [{ sID: "more", shopname: "⬇ Show More Shops", __isSpecial: true }]
        : []),
    ];
  }, [shops, preferredShops, showAllShops]);

  const filteredInventory = inventory.filter((p) =>
    p.productName?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const cartQuantity = cart.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0,
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Header3 />
        {/* <ChatWithCustomer />  */}
        <Card
          sx={{
            mx: "auto",
            mt: 8, // 🔥 reduced (header ke niche)
            mb: 4,
            maxWidth: 1500,
            width: "100%",
            borderRadius: 0,
            p: 2.5,
            boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
            background: "linear-gradient(135deg, #cdeecd 0%, #edf0ee 100%)",
          }}
        >
          {/* Header Row */}
          <Box display="flex" alignItems="center" gap={1.5}>
            {/* <IconButton
      onClick={() => navigate(-1)}
      sx={{
        backgroundColor: "#f5f5f5",
      }}
    >
      <ArrowBackIosNewIcon fontSize="small" /> 
    </IconButton> */}

            <Box>
              <Typography fontWeight={800} color="black">
                Hi, {customerName || "Customer"}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                Welcome to Sakhis Shop
              </Typography>
            </Box>
          </Box>
        </Card>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            px: 4,
            mt: 8,
          }}
        >
          <Card
            sx={{ ...cardStyle, flex: 1 }}
            onClick={() => navigate("/myorders")}
          >
            <ShoppingCartIcon sx={{ fontSize: 38, color: "#1976d2", mb: 1 }} />
            <Typography fontWeight={700} fontSize={15}>
              My Orders
            </Typography>
            <Typography fontSize={13} color="primary.main">
              View & Track →
            </Typography>
          </Card>

          <Card
            sx={{ ...cardStyle, flex: 1 }}
            onClick={() => navigate("/paymentdetails")}
          >
            <PaymentIcon sx={{ fontSize: 38, color: "#2e7d32", mb: 1 }} />
            <Typography fontWeight={700} fontSize={15}>
              Payments
            </Typography>
            <Typography fontSize={13} color="success.main">
              View Transactions →
            </Typography>
          </Card>
        </Box>
        <Container sx={{ mt: 4, flexGrow: 1, mb: 10 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 2,
              alignItems: "flex-start",
              mb: 3,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="h6" gutterBottom>
                Select a Shop
              </Typography>
              <Autocomplete
                openOnFocus
                options={computedOptions}
                getOptionLabel={(option) =>
                  option.__isSpecial
                    ? option.shopname
                    : (option?.shopname ?? "")
                }
                renderOption={(props, option) => {
                  if (option.__isSpecial) {
                    return (
                      <li
                        {...props}
                        key={option.sID}
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          color: "#1976d2",
                        }}
                      >
                        {option.shopname}
                      </li>
                    );
                  }

                  return (
                    <li {...props} key={option.sID}>
                      {option.shopname}
                    </li>
                  );
                }}
                onChange={(event, newValue) => {
                  if (!newValue) return;

                  if (newValue.__isSpecial) {
                    if (newValue.sID === "more") setShowAllShops(true);
                    if (newValue.sID === "less") setShowAllShops(false);
                    return;
                  }

                  setSelectedShop(newValue);
                  handleShopSelect(newValue.sID);
                  savePreferred(newValue.sID);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search shop..."
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Box>

            {shopProfile && (
              <Card
                sx={{
                  flex: 0.9,
                  minWidth: 280,
                  width: "100%",
                  boxShadow: 4,
                  p: 2,
                }}
              >
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  gutterBottom
                >
                  Selected shop
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                  {shopProfile.shopname}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  {shopProfile.address || "No address available."}
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" fontWeight={600}>
                      Owner
                    </Typography>
                    <Typography variant="body2">
                      {shopProfile.owner || "N/A"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body2" fontWeight={600}>
                      Contact
                    </Typography>
                    <Typography variant="body2">
                      {shopProfile.contactNumber || "N/A"}
                    </Typography>
                  </Grid>
                </Grid>
              </Card>
            )}
          </Box>

          {shopProfile && (
            <Paper
              sx={{ p: 3, mb: 4, boxShadow: 4, backgroundColor: "#f6fbf7" }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Selected shop
                  </Typography>
                  <Typography variant="h6" fontWeight={700}>
                    {shopProfile.shopname}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Current cart
                  </Typography>
                  <Typography variant="h6" fontWeight={700}>
                    {cartQuantity} item{cartQuantity === 1 ? "" : "s"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Total value
                  </Typography>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    color="success.main"
                  >
                    ₹ {cartTotal.toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          )}

          <Paper sx={{ p: 3, boxShadow: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                mb: 3,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Available products
              </Typography>
              <TextField
                fullWidth
                sx={{ maxWidth: 360 }}
                placeholder="Search product..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Box>

            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              }}
            >
              {filteredInventory.map((product) => (
                <Card
                  key={product.id}
                  sx={{
                    borderRadius: 2,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    opacity: product.inStock ? 1 : 0.6,
                  }}
                >
                  <CardContent>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        mb: 1,
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={700} noWrap>
                        {product.productName}
                      </Typography>
                      <Typography
                        variant="caption"
                        color={product.inStock ? "success.main" : "error.main"}
                        sx={{ fontWeight: 700 }}
                      >
                        {product.inStock ? "In stock" : "Out of stock"}
                      </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" noWrap>
                      {product.group || product.subCategory || "Product"}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mt: 2,
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight={800}
                        color="success.main"
                      >
                        ₹{product.customPrice ?? product.mrp}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {product.uom || "Unit"}
                      </Typography>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
                    <Button
                      variant="contained"
                      disabled={!product.inStock}
                      onClick={() => handleOpenProduct(product)}
                      sx={{ background: "#4CAF50" }}
                    >
                      Add to Cart
                    </Button>
                  </CardActions>
                </Card>
              ))}
            </Box>

            {filteredInventory.length === 0 && (
              <Typography sx={{ mt: 2, color: "text.secondary" }}>
                No products found. Try another shop or adjust your search.
              </Typography>
            )}
          </Paper>

          {cart.length > 0 && (
            <Card sx={{ p: 3, mt: 4, boxShadow: 4 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
                Cart summary
              </Typography>
              {cart.map((item, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  py={1}
                  borderBottom={
                    index < cart.length - 1 ? "1px solid #e0e0e0" : "none"
                  }
                >
                  <Box>
                    <Typography fontWeight={700}>{item.productName}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.quantity} {item.uom}
                    </Typography>
                  </Box>
                  <Typography fontWeight={700}>
                    ₹ {(item.price * item.quantity).toFixed(2)}
                  </Typography>
                </Box>
              ))}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
              >
                <Typography fontWeight={700}>Total</Typography>
                <Typography fontWeight={700} color="success.main">
                  ₹ {cartTotal.toFixed(2)}
                </Typography>
              </Box>
              <Button
                variant="contained"
                color="success"
                fullWidth
                sx={{ mt: 3 }}
                onClick={() => navigate("/mycart")}
              >
                Checkout
              </Button>
            </Card>
          )}

          <Dialog
            open={openQtyDialog}
            onClose={() => setOpenQtyDialog(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogContent>
              {/* PRODUCT HEADER */}

              <Box display="flex" justifyContent="space-between">
                <Typography variant="h6">
                  {selectedProduct?.productName}
                </Typography>

                <Typography color="green" fontWeight="bold">
                  ₹ {getPrice()} / {selectedProduct?.uom}
                </Typography>
              </Box>

              <Box mt={3} />

              {/* MODE BUTTONS */}

              <Box display="flex" gap={2}>
                {!isWeightProduct && (
                  <Button
                    variant={mode === "COUNT" ? "contained" : "outlined"}
                    onClick={() => setMode("COUNT")}
                    fullWidth
                  >
                    COUNT
                  </Button>
                )}

                {isWeightProduct && (
                  <Button
                    variant={mode === "WEIGHT" ? "contained" : "outlined"}
                    onClick={() => setMode("WEIGHT")}
                    fullWidth
                  >
                    WEIGHT
                  </Button>
                )}
              </Box>

              <Box mt={3} />

              {/* COUNT MODE */}

              {mode === "COUNT" && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                >
                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => quantity > 1 && setQuantity(quantity - 1)}
                  >
                    -
                  </Button>

                  <TextField
                    value={quantity}
                    size="small"
                    sx={{ width: 80 }}
                    inputProps={{ style: { textAlign: "center" } }}
                  />

                  <Button
                    variant="contained"
                    color="success"
                    onClick={() => setQuantity(quantity + 1)}
                  >
                    +
                  </Button>
                </Box>
              )}

              {/* WEIGHT MODE */}

              {mode === "WEIGHT" && (
                <Box>
                  <Box display="flex" gap={1} mb={2}>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => setQuantity(0.25)}
                    >
                      250g
                    </Button>

                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => setQuantity(0.5)}
                    >
                      500g
                    </Button>

                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => setQuantity(1)}
                    >
                      1kg
                    </Button>

                    <Button
                      variant="contained"
                      color="success"
                      onClick={() => setQuantity(2)}
                    >
                      2kg
                    </Button>
                  </Box>

                  <TextField
                    label="Custom Weight (kg)"
                    type="number"
                    fullWidth
                    value={quantity}
                    onChange={(e) =>
                      setQuantity(parseFloat(e.target.value) || 0)
                    }
                  />
                </Box>
              )}

              <Box mt={3} />

              {/* TOTAL */}

              <Box display="flex" justifyContent="space-between">
                <Typography>Total Amount</Typography>

                <Typography fontWeight="bold">
                  ₹ {totalAmount.toFixed(2)}
                </Typography>
              </Box>
              <Box mt={2} />

              {/* ADD TO CART */}

              <Button
                variant="contained"
                color="success"
                fullWidth
                onClick={handleAddToCart}
              >
                Add To Cart
              </Button>
            </DialogContent>
          </Dialog>

          {/* CART */}
          {/* 
{cart.length > 0 && (

<Card sx={{p:2, mt:3}}>

<Typography variant="h6">
Cart
</Typography>

{cart.map((item,index)=>(

<Box
key={index}
display="flex"
justifyContent="space-between"
mt={1}
>

<Typography>

{item.productName}

</Typography>

<Typography>

{item.quantity} {item.uom}


</Typography>

<Typography>

₹ {(item.price * item.quantity).toFixed(2)}
</Typography>

</Box>

))}

<Box
display="flex"
justifyContent="space-between"
mt={2}
>

<Typography fontWeight="bold">
Total
</Typography>

<Typography fontWeight="bold">

₹ {cartTotal.toFixed(2)}

</Typography>

</Box>


<Button
variant="contained"
color="success"
fullWidth
sx={{ mt:2 }}
onClick={() => navigate("/mycart")}
>
Checkout
</Button>


</Card>

)}
 */}
        </Container>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          message={snackbar.msg}
          onClose={() => setSnackbar({ open: false, msg: "" })}
        />
      </div>
    </ThemeProvider>
  );
};

export default CustomerDashboard;
